<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="确认订单" left-arrow fixed @click-left="back"  right-text="新增地址"  @click-right="toAddressAdd"/>
         <div class="jump-order-address order-cell-item" 
            v-if="addr.id==addrId"
            @click="setAddrId(addr.id)"
            v-for="addr in addressList" 
            :class="addr.id==addrId?'active':''">
            <p>{{addr.path}}</p>
            <h5>{{addr.area_info}} 
                <van-icon name="passed" v-if="addr.id==addrId"/>
                   <!-- <van-icon name="arrow" @click="setAddrId(i,addr.id)"/> -->
                </h5>
            <p>{{addr.trueName}} {{addr.mobile}}</p>
        </div>
        <div class="jump-order-address order-cell-item" v-if="addrId==0">
            <p>无可用地址，请先添加<a href="#/user/address" class="blue">收货地址</a></p>
        </div>
        <div class="order-cell-item" v-for="(item,index) of goodsList" :key="index">
            <van-row class="jump-cart-item" type="flex">
              <van-col span="8" class="jump-cart-item-img">
                  <img v-bind:src="item.imges" />
              </van-col>
              <van-col span="16" class="jump-cart-item-warp">
                  <h4 class="text-ellipsis">{{item.name}}</h4>
                    <p class="">销售单位：{{item.goodsUnit}}</p>
                  <p>积分:{{item.integral}}</p>
                  <p class="jump-cart-item-price">总积分:{{item.integral * goodsCartJson[index]['goodsCount']}}</p>
                  <van-stepper class="jump-cart-item-num" v-model="goodsCartJson[index]['goodsCount']" @minus="numChange(-1,index)" @plus="numChange('1',index)" @blur="numChange('',index)"/>
              </van-col>
             
          </van-row>
           <van-row style="text-align:right" ><span class="delete" @click="delGoods(index)">删除</span></van-row>
        </div>

        <div class="order-cell-item">
            <van-cell  title="商品总积分" :value="integralValue" class="red"/>
            <van-field label="留言" placeholder="建议留言前先和商家沟通确认" v-model="orderParams.remark"/>
        </div>
        <div class="foot">
       <a href="#/integral/home" >
           <van-button round type="info">继续兑换</van-button>
       </a>
        <van-button type="info" round size="small" @click="orderSubmit" class="order-submit">确认订单
                                </van-button>
        </div>
         <van-popup v-model="popAddr" position="bottom" style="width:100%;height:75%">
            <van-radio-group v-model="addrId" @change="closePopAddr">
                <div class="jump-order-address order-cell-item"
                     v-for="(addr,i) in addressList"
                     :class="addr.id==addrId?'active':''">
                    <p>{{addr.path}}</p>
                    <h5 style="position:relative;">{{addr.area_info}}
                        <van-radio :name="addr.id" style="position:absolute;right:0;top:5px;"/>
                    </h5>``
                    <p>{{addr.trueName}} {{addr.mobile}}</p>
                </div>
            </van-radio-group>
            <div class="jump-order-address order-cell-item" v-if="addrId==0">
                <p>无可用地址，请先添加<a href="#/user/address" class="blue">收货地址</a></p>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { NavBar, Row, Col, Field, Button, Cell, CellGroup,Stepper,SubmitBar,RadioGroup, Radio,DatetimePicker, Popup, Picker, } from "vant";

export default {
  name: "integralorder",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [SubmitBar.name]: SubmitBar,
    [Stepper.name]: Stepper,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [DatetimePicker .name]:DatetimePicker 
  },
  data() {
    return {
        goodsList:[],//商品列表
        good:{},
        popAddr: false,
        goodsId:0,
        count:1,
        addrId:0,
        addressList:[],
        goodsCartJson:[],//商品id,数量等
        orderParams:{
            addrId:0,
            remark:'',
        },
    };
  },
  computed:{
       integralValue(){
           var sum=0;
            for(var i=0;i<this.goodsList.length;i++){
                 let count=1;
                  sum+=this.goodsList[i]["integral"]*this.goodsCartJson[i]["goodsCount"]
            }
             return sum
       }
      
  },
  methods: {
    back() {
      history.back();
    },
     toAddressAdd() {
                location.href="#/user/address"
            },
    numChange(type,index){
        let that = this;
        if(type=='-1'){//减少
         that.goodsCartJson[index].goodsCount-=1;
        }else if(type=='1'){//增加
             that.goodsCartJson[index].goodsCount+=1;
        }
        that.$api.post(that.jumuc.integral.adjustCount,{goodsId: that.goodsCartJson[index]["goodsId"],goodsCount:that.goodsCartJson[index].goodsCount},successRes=>{
            if(!successRes.success){
                 that.$toast(successRes.msg);
                that.goodsCartJson[index].goodsCount = successRes.data.count;
            }
        })
    },
    orderSubmit(){//确认订单
        let that = this;
        if(that.addrId==0){
             that.$toast('请选择收货地址');
            return;
        }
        let params=this.orderParams;
        params["goodsCartJson"]=this.goodsCartJson;
        that.$api.post(that.jumuc.integral.createOrder,params,successRes=>{
            if(successRes.success){
                 sessionStorage.setItem('integralGoods',JSON.stringify([]));
                location.href="#/integral/order/success?orderId="+successRes.data.orderId+"&integral="+successRes.data.consumeIntegral;
            }else{
                that.$toast(successRes.msg);
            }
        })
    },
    selAddrList() {//地址列表
        let that = this
        that.$api.post(
            that.jumuc.userCenter.selAddrList,
            null,
            successRes => {
                that.addressList = successRes.data;
                that.addrId = that.addressList.length > 0 ? that.addressList[0].id : 0;
                that.orderParams.addrId = that.addrId;
            }
        )
    },
    setAddrId(addrId){
        this.addrId = addrId;
        this.orderParams.addrId = this.addrId;
        this.popAddr=true;
    },
     closePopAddr() {
                let that = this;
                setTimeout(() => {
                    that.popAddr = false;
                }, 100);
                this.orderParams.addrId = this.addrId;
            },
            delGoods (index){
                  this.goodsList.splice(index,1);
                  sessionStorage.setItem('integralGoods',JSON.stringify(this.goodsList));
            }
  },
  mounted(){
    let that = this;
    let isCun=false;
    this.goodsId = this.$route.query.goodsId;
    that.goodsList=JSON.parse(sessionStorage.getItem('integralGoods'))?JSON.parse(sessionStorage.getItem('integralGoods')):[];
    if(that.goodsList.length>0){
        //判断缓存里是否有该商品
       for(var i=0;i<this.goodsList.length;i++){
              if(this.goodsList[i].id==this.goodsId){
                     isCun=true;
              }
                    that.goodsCartJson.push({
                        goodsId:this.goodsList[i].id,
                        categoryId:this.goodsList[i].categoryId,
                        goodsCount:1
                    })
               }
    }        
    //商品详情
    this.$api.get(this.jumuc.integral.goodsDetail,{id:that.goodsId},
          successRes =>{
            if(successRes.success){
              that.good = successRes.data;
              if(!isCun){
                this.goodsCartJson.push({
                         goodsId:this.good.id,
                        categoryId:this.good.categoryId,
                        goodsCount:1
                     })
              this.goodsList.push(successRes.data);
              sessionStorage.setItem('integralGoods',JSON.stringify(this.goodsList));
              }
              
            }
          })
    this.selAddrList();
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
.foot{
    position:fixed;
    bottom:0;
    left:20px;
    right:20px;
    z-index:1000;
    background:#fff;
    display:flex;
    justify-content: space-between;
}
.red span{
    color:red;
    font-size:17px;
}
.foot button{
    width:130px;
    height:42px;
    font-size:14px;
}
.order-submit{
    background-color: #f57c23;
    border-color: #f57c23;
}
.delete{
    color: red;
    display: inline-block;
    width: 70px;
    padding: 10px 0;
    text-align: center;
}
body{
    background-color: #f7f7f7;
}
.jump-order {

  padding-bottom: 100px;
  .order-cell-item{
      background-color: #fff;
      padding: 10px 15px;
      margin-bottom: 15px;
  }
  &-address{
      p{
          color: #999
      }
      h5{
          font-size: 18px;
          font-weight: 600;
          padding: 5px 0;
          i{
              float: right
          }
      }
  }
  &-address.active{
    color: @bule-thame;
      p{
          color: @bule-thame
      }
      h5{
          font-size: 18px;
          font-weight: 600;
          padding: 5px 0;
          i{
              float: right
          }
      }
  }

  
  .jump-cart-item {
    margin-bottom: 15px;
    align-items: center;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 90%;
      }
    }

    h4 {
      font-size: 14px;
      padding: 10px 0;
    }
    &-warp {
      align-self: flex-start;
      padding-left: 10px;
    }
    p {
      font-size: 14px;
    }
    &-price {
      color: red;
      font-size: 16px;
      font-weight: 500;
    }
    &-num {
      position: absolute;
      right: 20px;
      bottom: 10px;
    }
  }
  .order-submit{
      button{
          display: inline-block;
          width: auto;
          height: 40px;
          line-height: 40px;
          margin-right: 10px;
          border-radius: 25px;
          padding: 0 30px;
          font-size: 14px;
          background-color: #f5a623;
          border-color: #f5a623;
      }
      p{
          padding-left: 15px;
          color: red;
          font-size: 18px;
      }
  }
  .order-fre{
      .van-cell__value{
          color: red;
      }
  }
  .van-radio{
      display: inline-block;
      margin-left: 10px;
  }

  .invoice-warp{
      .van-field__control[readonly]{
          color: @bule-thame;
          opacity:1;
      }
  }
  
  .van-cell:not(:last-child)::after{
    border-width: 0;
  }
}
</style>

